export enum ApprovalRequestState {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
    WITHDRAWN = 'WITHDRAWN',
    EXPIRED = 'EXPIRED',
}
